import React, { useEffect } from 'react';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';

import { toI18n } from 'util/i18n';
import {
  ELEMENTS,
  EVENT_ACTIONS,
  TRACK_ACTION_TYPES,
} from 'util/tracking_constants';

const LaunchWeekStepTopLocalWorkplace = ({ onNextStep, trackUx }) => {
  const setTimeoutId = onNextStep();

  useEffect(() => {
    trackUx(EVENT_ACTIONS.PAGE_VIEWED, TRACK_ACTION_TYPES.VIEW, {
      step_label: ELEMENTS.LAUNCH_WEEK_STEP_LABELS.TOP_LOCAL_WORKPLACE,
    });
    return () => {
      clearTimeout(setTimeoutId);
    };
  }, [setTimeoutId, trackUx]);

  return (
    <Box column hcenter className="content-fade-in-and-out">
      <Box tcenter>
        <Text variant="display1" color="mono0" asHTML>
          {toI18n('growth.launch_week.steps.top_local_workplace.title')}
        </Text>
      </Box>
      <Box tcenter mt={12}>
        <Text variant="display1" color="mono0" asHTML>
          {toI18n('growth.launch_week.steps.top_local_workplace.subtitle')}
        </Text>
      </Box>
    </Box>
  );
};

export default LaunchWeekStepTopLocalWorkplace;
